// R12d: one date format everywhere. Calls without a locale print 23.09.2026 and 23.09.2026 14:05.
const pad = (n) => String(n).padStart(2, "0");
const d = (x) => `${pad(x.getDate())}.${pad(x.getMonth() + 1)}.${x.getFullYear()}`;
const origDate = Date.prototype.toLocaleDateString;
const origStr = Date.prototype.toLocaleString;
Date.prototype.toLocaleDateString = function (...a) { return a.length || isNaN(this) ? origDate.apply(this, a) : d(this); };
Date.prototype.toLocaleString = function (...a) { return a.length || isNaN(this) ? origStr.apply(this, a) : `${d(this)} ${pad(this.getHours())}:${pad(this.getMinutes())}`; };

export const dmy = (s) => (s && /^\d{4}-\d{2}-\d{2}/.test(String(s)) ? `${String(s).slice(8, 10)}.${String(s).slice(5, 7)}.${String(s).slice(0, 4)}` : s || "");
